import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services';

@Component({
  selector: 'app-workshop-jobcard-collections-deliveries-preview',
  templateUrl: './workshop-jobcard-collections-deliveries-preview.component.html',
  styleUrls: ['./workshop-jobcard-collections-deliveries-preview.component.scss']
})
export class WorkshopJobcardCollectionsDeliveriesPreviewComponent {
  @Input() collectionsDeliveries: any;

  countryData: any = this.helpersService.getCountryData();

  constructor(
    private translate: TranslateService,
    private helpersService: HelpersService
  ) { }

  hasCollectionData(): boolean {
    return this.collectionsDeliveries?.allowCollection && 
           this.collectionsDeliveries?.collectionInfo &&
           (this.collectionsDeliveries.collectionInfo.fullAddress || this.collectionsDeliveries.collectionInfo.scheduleDate);
  }

  hasDeliveryData(): boolean {
    return this.collectionsDeliveries?.allowDelivery && 
           this.collectionsDeliveries?.deliveryInfo &&
           (this.collectionsDeliveries.deliveryInfo.fullAddress || this.collectionsDeliveries.deliveryInfo.scheduleDate);
  }

  getStatusLabel(statusID: number, type: 'collection' | 'delivery'): string {
    if (type === 'collection') {
      switch (statusID) {
        case 0: return this.translate.instant('bikeshop.collections.status.pending');
        case 10: return this.translate.instant('bikeshop.collections.status.collected');
        default: return this.translate.instant('bikeshop.collections.status.unknown');
      }
    } else {
      switch (statusID) {
        case 0: return this.translate.instant('bikeshop.deliveries.status.pending');
        case 20: return this.translate.instant('bikeshop.deliveries.status.delivered');
        default: return this.translate.instant('bikeshop.collections.status.unknown');
      }
    }
  }

  getStatusClass(statusID: number): string {
    switch (statusID) {
      case 10:
      case 20:
        return 'status-completed';
      case 0:
        return 'status-pending';
      default:
        return 'status-unknown';
    }
  }

  formatTimeSlot(startTime: string, endTime: string): string {
    if (!startTime || !endTime) return '';
    
    // Convert time strings to display format
    const start = this.formatTime(startTime);
    const end = this.formatTime(endTime);
    
    return `${start} - ${end}`;
  }

  private formatTime(timeString: string): string {
    if (!timeString) return '';
    
    // Parse time string and convert to 12-hour format
    const timeParts = timeString.split(':');
    if (timeParts.length >= 2) {
      const hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const displayHours = hours % 12 || 12;
      return `${displayHours}:${minutes} ${ampm}`;
    }
    return timeString;
  }

  truncateAddress(address: string, maxLength: number = 50): string {
    if (!address) return '';
    return address.length > maxLength ? address.substring(0, maxLength) + '...' : address;
  }
}
